import { render, staticRenderFns } from "./TicketOpener.vue?vue&type=template&id=c2f80d34&scoped=true"
import script from "./TicketOpener.vue?vue&type=script&lang=js"
export * from "./TicketOpener.vue?vue&type=script&lang=js"
import style0 from "./TicketOpener.vue?vue&type=style&index=0&id=c2f80d34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f80d34",
  null
  
)

export default component.exports